import {Field, FieldOperations, OpsCategories, SqlOperation, TableI} from "../../Types";
import {nanoid} from "@reduxjs/toolkit";


const fieldOperations: FieldOperations = {
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
    dt: [...OpsCategories.range],
    msisdn: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    banned: [...OpsCategories.eq],
    user_id: [...OpsCategories.eq],
    chat_id: [...OpsCategories.eq],
    thread_id: [...OpsCategories.eq],
};

export function tgUsers287DefFilters() {
    return [
        {
            nanoid: nanoid(),
            field: 'msisdn',
            type: 'tel',
            filterOp: SqlOperation.LIKE,
            locked: true,
            value: ''
        }
    ]
}

export const TgUsersTable: TableI = {
    backend: "/287/",
    title: {
        ua: "TG usr",
    },
    forAdmin: true,
    pk: 'id',
    defaultOrderedBy: "dt",
    defaultOrderedWay: "DESC",
    defaultPerPage: 20,
    orderByFields: {
        "dt": {ua: "Створено", ru: "Дата"},
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'tgUsers287DefFilters',
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№", ru: "№"}, type: "number",
            applyTransform: true
        }, {
            key: "id",
            detailed: true,
            title: {ua: "ID", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "msisdn", type: 'tel',
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Телефон", ru: "Телефон"}
        },
        {
            key: "user_id",
            detailed: true,
            title: {ua: "ID Ariston", ru: "№"},
            type: "number",
            applyTransform: true,
            inline: true
        },
        {
            key: "chat_id",
            detailed: true,
            title: {ua: "chat_id", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "thread_id",
            detailed: true,
            title: {ua: "thread_id", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "banned",
            detailed: true,
            title: {ua: "Забанений"},
            type: "boolean",
            applyTransform: true,
            inline: true,
            editable: true
        },
        {
            key: "dt",
            title: {ua: "Створено", ru: "Дата"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true,
            inline: true,
        },

    ] as Field[]
}


